import React from 'react';
import { MapSearch } from './MapSearch';
import { Property } from '../../services/api';
import {
  StickyHeader,
  DesktopNav,
  DesktopPhonePill,
  BrandLogo,
} from '../../design-system/components';

interface MapHeaderProps {
  searchQuery: string;
  setSearchQuery: (v: string) => void;
  setSearchFocused: (v: boolean) => void;
  searchSuggestions: Property[];
  showSearchDropdown: boolean;
  handleSuggestionSelect: (p: Property) => void;
  onLocateClick: () => void;
}

// StickyHeader — 로고 (전 viewport) + DesktopNav (md+) + 검색 (center) + 우측 액션
// 사용자 피드백 (2026-05-19): 모바일 "뒤로" 버튼 제거 (메인 = 지도이므로 뒤로갈 곳 없음).
// 로고로 교체.
export const MapHeader: React.FC<MapHeaderProps> = ({
  searchQuery,
  setSearchQuery,
  setSearchFocused,
  searchSuggestions,
  showSearchDropdown,
  handleSuggestionSelect,
  onLocateClick,
}) => {
  return (
        <div className="absolute inset-x-0 top-0 z-[15]">
          <StickyHeader
            left={
              <div className="flex items-center gap-6">
                <BrandLogo />
                <DesktopNav />
              </div>
            }
            center={
              <MapSearch
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                setSearchFocused={setSearchFocused}
                searchSuggestions={searchSuggestions}
                showSearchDropdown={showSearchDropdown}
                handleSuggestionSelect={handleSuggestionSelect}
              />
            }
            centerMode="always"
            forceCompact={false}
            right={
              <>
                <DesktopPhonePill className="mr-1" />
                <button
                type="button"
                onClick={onLocateClick}
                className="flex h-11 w-11 items-center justify-center rounded-ca-md text-muted hover:bg-ca-surface hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-ink"
                aria-label="현재 위치"
              >
                <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                  <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="2" />
                </svg>
              </button>
              </>
            }
          />
        </div>
  );
};
